import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalServices } from '../global.services';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(
    private globalServices: GlobalServices
  ) { }

  subscriptionForFooter = new Subscription;
  subscriptionForFooterAgain =  new Subscription;
  showFooter = false;
  ngOnInit(): void {
    if(this.globalServices?.isBrowser){
      this.subscriptionForFooter =  this.globalServices.hideHeader.subscribe((response) => {
        if(response){
          // this.showFooter = false;
        }else{
          this.showFooter = true;
        }
      })
      this.subscriptionForFooterAgain =  this.globalServices.hideFooter.subscribe((response) => {
        if(response){
          this.showFooter = false;
        }else{
          this.showFooter = true;
        }
      })
    }
  }
  goToUrl(urlLink){
    if(this.globalServices?.isBrowser && urlLink){
      window.open(urlLink);
    }
  }
  ngOnDestroy(){
    this.subscriptionForFooter.unsubscribe();
  }
}
